export interface IBaseUser {
  uuid: string;
  first_name: string;
  last_name: string;
  email: string;
}

export const USER_ROLES = {
  member: 'member',
  admin: 'admin',
  pending: 'pending',
} as const;
export type TUserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];
